import { render } from "./AddNewUserToMyRestaurant.vue?vue&type=template&id=9fe6fd80&scoped=true"
import script from "./AddNewUserToMyRestaurant.vue?vue&type=script&lang=js"
export * from "./AddNewUserToMyRestaurant.vue?vue&type=script&lang=js"

import "./AddNewUserToMyRestaurant.vue?vue&type=style&index=0&id=9fe6fd80&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe6fd80"]])

export default __exports__